var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivraison(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0350a5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -295,
    y: -61,
    display: "inline",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    width: 1334,
    height: 584
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.927,49.883h-13.3v2.809h13.3v19.538h4.84c0.659,4.026,4.152,7.11,8.361,7.11s7.702-3.085,8.361-7.11h27.32    c0.659,4.026,4.152,7.11,8.361,7.11s7.702-3.085,8.362-7.11h4.84V46.65L80.966,33.244H67.318V20.66h-43.39v11.223h-9.3v2.809h9.3    v6.191h-18.3v2.809h18.3V49.883z M37.129,76.531c-3.128,0-5.674-2.545-5.674-5.674c0-3.129,2.545-5.674,5.674-5.674    s5.674,2.545,5.674,5.674C42.802,73.986,40.257,76.531,37.129,76.531z M81.171,76.531c-3.128,0-5.674-2.545-5.674-5.674    c0-3.129,2.545-5.674,5.674-5.674c3.129,0,5.674,2.545,5.674,5.674C86.845,73.986,84.3,76.531,81.171,76.531z M67.318,36.052    h12.485l11.761,11.761v21.608h-2.041c-0.686-3.994-4.165-7.046-8.352-7.046s-7.666,3.052-8.351,7.046H45.48    c-0.686-3.994-4.164-7.046-8.351-7.046s-7.666,3.052-8.351,7.046h-2.041v-8.202h40.582V36.052z M26.736,40.883v-6.191h8.892    v-2.809h-8.892v-8.415h37.773V58.41H26.736v-5.718h10.892v-2.809H26.736v-6.191h4.892v-2.809H26.736z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.17,49.694l-9.249-9.249h-6.166V55.86H87.17V49.694z M84.362,53.051h-9.798v-9.798h2.194l7.604,7.604V53.051z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivraison);
export default __webpack_public_path__ + "static/media/livraison.2a10e9440be361f97a7e63ea8c2c7541.svg";
export { ForwardRef as ReactComponent };